<template>
    <button type="button" class="row__action action-button" v-on="$listeners">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'ActionButton',
    };
</script>
